import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-conversation-refresh-icon',
},
  __name: 'conversation-refresh-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle({ fill: __props.fill }),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 29.211 29.727"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("path", { d: "M17.368 10.298c.136.242.456.435.732.436l10.348.058c.268.002.512-.138.652-.366.141-.228.145-.517.023-.755L24.404.441c-.126-.248-.409-.429-.685-.438-.278-.012-.606.085-.752.321L21.52 2.671C19.43 1.49 17.032.797 14.464.797 6.489.795 0 7.285 0 15.261c0 7.977 6.489 14.466 14.466 14.466 7.976 0 14.465-6.489 14.465-14.466 0-.873-.09-1.725-.239-2.556-.08.007-.156.029-.237.029h-.021l-4.858-.014c.226.81.355 1.659.355 2.54 0 5.219-4.246 9.466-9.465 9.466C9.246 24.727 5 20.479 5 15.261c0-5.22 4.246-9.466 9.466-9.466 1.605 0 3.11.415 4.435 1.125l-1.58 2.563c-.146.236-.087.572.047.815z" }, null, -1)
    ]), 4))
  ]))
}
}

})